<div class="chart-area">
	<canvas baseChart class="chart" [data]="data" [options]="options" [type]="type" style="padding: 10px !important;" [style.max-width]="width + ' !important'" [style.max-height]="height + ' !important'"> </canvas>
</div>
